import axios from "axios";
import Cookies from "js-cookie";
import { apiUri } from "./apiManager";

const getLanguage = () => document.documentElement.lang || "en";

// Callback storage to avoid circular dependency with the store
// The store will register its auth-clearing handler during initialization
let authClearCallback = null;

export const registerAuthClearCallback = (callback) => {
  authClearCallback = callback;
};

const axiosInstance = axios.create({
  baseURL: apiUri,
  timeout: 20000,
});

axiosInstance.interceptors.request.use((config) => {
  const token = Cookies.get("accessToken");
  config.headers = config.headers || {};
  if (token) {
    config.headers["auth-token"] = "Bearer " + token;
  }
  config.headers["Accept-Language"] = getLanguage();
  return config;
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      if (authClearCallback) {
        try {
          authClearCallback();
        } catch (err) {
          console.error("Failed to clear auth on 401:", err);
        }
      } else {
        console.warn("Auth clear callback not registered");
      }
    }
    return Promise.reject(error);
  }
);

export const noAuthAxios = axios.create({
  baseURL: apiUri,
  timeout: 20000,
});

noAuthAxios.interceptors.request.use((config) => {
  config.headers = config.headers || {};
  config.headers["Accept-Language"] = getLanguage();
  return config;
});

export default axiosInstance;
